import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import { alertService } from '../../../../shared/services/alertService';
import { usePlanningWizard } from '../PlanningWizardContext';
import { STAFF_COLUMNS, StaffEntry } from '../types';
import { SUBJECT_DESIGNATIONS } from '../../../../shared/services/commonService';

/**
 * Step 2 — Staff Type + Subject (Angular addStaff / deleteStaffList /
 * secondStepSubmit). Subject is required only for certain staff types; entries
 * are de-duplicated on Subject; after the first add the staff-type dropdown
 * locks (Angular StaffDisable).
 */
const StepStaff = () => {
  const {
    staffTypeList,
    subjectList,
    staffType,
    setStaffType,
    subject,
    setSubject,
    isShowSubject,
    staffDisable,
    setStaffDisable,
    staffList,
    setStaffList,
    nextPage,
    previousPage,
  } = usePlanningWizard();

  const staffAddValid = false;

  const addStaff = () => {
    if (!staffType && !subject) {
      alertService.error('Please select mandatory fields');
      return;
    }

    let valid = true;
    if (SUBJECT_DESIGNATIONS.includes(staffType)) {
      if (!staffType || !subject) {
        valid = false;
        alertService.error('Please select staff type and subject');
      }
    } else if (!staffType) {
      valid = false;
      alertService.error('Please select staff type');
    }

    // Dedup on Subject (Angular blocks duplicate subject entries).
    const duplicate = staffList.filter(
      (ft) => ft.Subject === (subject || null)
    );
    if (duplicate.length > 0) {
      valid = false;
      alertService.error('Duplicate entry');
    }

    if (!valid) return;

    const desig = staffTypeList.filter((sf) => sf.value === staffType);
    const sub = subjectList.filter((sf) => sf.value === subject);
    const entry: StaffEntry = {
      Designation: desig.length > 0 ? desig[0].value : '',
      DesignationName: desig.length > 0 ? desig[0].label : '',
      SubjectName: sub.length > 0 ? sub[0].label : null,
      Subject: sub.length > 0 ? sub[0].value : null,
    };
    setStaffList((prev) => [...prev, entry]);
    setStaffDisable(true);
    setSubject('');
  };

  const deleteStaffList = (index: number) => {
    setStaffList((prev) => {
      const next = prev.filter((_, i) => i !== index);
      if (next.length === 0) setStaffDisable(false);
      return next;
    });
  };

  const secondStepSubmit = () => {
    if (staffList.length > 0) {
      nextPage();
    } else {
      alertService.error('Please add alteast one designation');
    }
  };

  return (
    <div className="card p-4">
      <div className="row">
        <div className="col-3">
          <label className="inMandatory">Staff Type</label>
          <Dropdown
            value={staffType}
            options={staffTypeList}
            optionLabel="label"
            optionValue="value"
            placeholder="Select a staff type"
            filter
            filterBy="label"
            disabled={staffDisable}
            showClear={!!staffType}
            appendTo="self"
            className="w-100"
            onChange={(e) => setStaffType(e.value ?? '')}
          />
        </div>

        {isShowSubject && (
          <div className="col-3">
            <label className="inMandatory">Subject</label>
            <Dropdown
              value={subject}
              options={subjectList}
              optionLabel="label"
              optionValue="value"
              placeholder="Select a subject"
              showClear={!!subject}
              appendTo="self"
              className="w-100"
              onChange={(e) => setSubject(e.value ?? '')}
            />
          </div>
        )}

        <div className="col-3 mt-4 pt-1">
          <Button
            type="button"
            label="Add"
            icon="pi pi-angle-right"
            iconPos="right"
            disabled={staffAddValid}
            onClick={addStaff}
          />
        </div>
      </div>
      <br />

      <div className="Counselling-Secondary">
        <DataTable
          value={staffList}
          paginator
          rows={10}
          rowsPerPageOptions={[10, 25, 50]}
          rowHover
          stripedRows
          responsiveLayout="scroll"
          emptyMessage="No Records Found"
        >
          <Column
            header="S.No"
            body={(_row, options) => options.rowIndex + 1}
            style={{ width: '5rem' }}
          />
          {STAFF_COLUMNS.map((col) => (
            <Column
              key={col.field}
              field={col.field}
              header={col.header}
              body={(row) => row[col.field] || '-'}
            />
          ))}
          <Column
            header="Remove"
            alignHeader="center"
            body={(_row, options) => (
              <div className="text-center">
                <i
                  className="pi pi-times-circle cursor-pointer text-danger"
                  role="button"
                  tabIndex={0}
                  onClick={() => deleteStaffList(options.rowIndex)}
                />
              </div>
            )}
          />
        </DataTable>
      </div>

      <div className="row mt-4">
        <div className="col-6">
          <Button
            type="button"
            icon="pi pi-angle-left"
            label="Previous"
            className="p-button-danger"
            onClick={previousPage}
          />
        </div>
        <div className="col-6 text-end">
          <Button
            type="button"
            icon="pi pi-angle-right"
            iconPos="right"
            label="Next"
            className="p-button-success"
            onClick={secondStepSubmit}
          />
        </div>
      </div>
    </div>
  );
};

export default StepStaff;
